import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveLine } from '@nivo/line';
import { formatNumberWithSpaces } from 'utils/index';

const DEFAULT_COLOR = '#277134';

const EvolutionLineChart = ({ data }) => {
  const { t } = useTranslation();

  const SERIES_COLORS = {
    [t('simulation.result.keyNumbers.grossMargin')]: '#277134',
    [t('simulation.result.keyNumbers.revenue')]: '#e69636',
  };

  if (!data?.length) return null;

  const chartColors = data.map((serie) => SERIES_COLORS[serie.id] || DEFAULT_COLOR);

  return (
    <div id="marge-graph">
      <div className="line-chart-card">
        <div className="line-chart-container">
          <ResponsiveLine
            data={data}
            margin={{ top: 20, right: 100, bottom: 40, left: 70 }}
            xScale={{ type: 'point' }}
            yScale={{
              type: 'linear',
              min: 'auto',
              max: 'auto',
              stacked: false,
              reverse: false,
            }}
            yFormat=" >-,.0f"
            colors={chartColors}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 4,
              tickPadding: 4,
              tickRotation: 0,
              legend: t('simulation.common.campaign'),
              legendOffset: 30,
              legendPosition: 'middle',
              format: (value) => {
                const year = Number(value);
                return isNaN(year) ? value : `${year}-${year + 1}`;
              },
            }}
            axisLeft={{
              tickSize: 4,
              tickPadding: 4,
              tickRotation: 0,
              legend: t('simulation.result.keyNumbers.amount'),
              legendOffset: -55,
              legendPosition: 'middle',
              format: (value) => formatNumberWithSpaces(value),
            }}
            pointSize={8}
            pointColor={{ from: 'serieColor' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh={true}
            legends={[
              {
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 90,
                translateY: 0,
                itemsSpacing: 4,
                itemWidth: 80,
                itemHeight: 16,
                itemOpacity: 0.75,
                symbolSize: 10,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
              },
            ]}
            tooltip={({ point }) => (
              <div className="tooltip">
                <strong>{point.serieId}</strong>
                <br />
                {t('simulation.common.campaign')}: {point.data.xFormatted}
                <br />
                {t('simulation.result.keyNumbers.amount')}:{' '}
                {formatNumberWithSpaces(point.data.yFormatted)} €
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default EvolutionLineChart;
